import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";

import { UniversityAction } from "../../store/actions";

import { Buttons, Modal } from "..";

const UploadVisaInfo = ({ text = "Upload", width = "8em" }) => {
  const dispatch = useDispatch();
  const fileSelectRefs = useRef({});

  const { isAddLoading } = useSelector((state) => state?.university);

  const [modalVisible, setModalVisible] = useState(false);

  const sheetNames = [{ label: "Visa Information", value: "visaInfo" }];

  const handleUpload = (file, sheet) => {
    const formdata = new FormData();
    formdata.append("page", sheet);
    formdata.append("file", file);

    const key = "uploadMessage";
    message.loading({
      content: "Data is being updated in the backend",
      key,
      duration: 0,
    });

    dispatch(
      UniversityAction.addUniversitySheet(formdata, (res) => {
        if (res.status === 200) {
          message.success({
            content: "Data updated successfully",
            key,
            duration: 2,
          });
        }
      })
    );
    setModalVisible(false);

    if (fileSelectRefs.current[sheet]) {
      fileSelectRefs.current[sheet].value = "";
    }
  };

  return (
    <div className={`${width}`}>
      <Buttons.DefaultButton
        size="medium"
        width="full"
        onClick={() => setModalVisible(true)}
        disabled={isAddLoading}
      >
        {text}
      </Buttons.DefaultButton>
      <Modal.DefaultModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
      >
        <div className="w-[35em] flex flex-col gap-4 justify-center items-center">
          <div className="text-main font-bold text-[2em]">
            Upload Visa Information
          </div>
          <div className="w-full">
            {sheetNames.map((item, index) => (
              <div key={index}>
                <div
                  className="cursor-pointer border border-dashed border-main rounded-xl p-5 text-center w-full"
                  onClick={() => fileSelectRefs.current[item.value]?.click()}
                >
                  Select File
                </div>
                <input
                  type="file"
                  style={{ display: "none" }}
                  accept=".xlsx"
                  ref={(el) => (fileSelectRefs.current[item.value] = el)}
                  onChange={(event) => {
                    if (event.target.files.length > 0) {
                      handleUpload(event.target.files[0], item.value);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default UploadVisaInfo;
